import type { Icon } from '@phosphor-icons/react';
import LureoButton from '@/common/LureoButton';

interface Props {
  icon: Icon;
  label: string;
  loading?: boolean;
  disabled?: boolean;
  onClick: () => void;
}

export function PillButton({ icon: Glyph, label, loading = false, disabled, onClick }: Props) {
  return (
    <LureoButton
      variant="outline-2"
      suppressTooltip
      onClick={onClick}
      disabled={loading || disabled}
      // Outlined in the brand ink, as production drew the flow's small actions
      className="h-7 shrink-0 gap-1.5 rounded-lureo-radius-button-pill border-lureo-border-width-medium border-lureo-brand-ink bg-lureo-surface px-3 text-lureo-12 font-medium text-lureo-brand-ink hover:border-lureo-brand-ink hover:bg-lureo-brand-ink/[0.08] hover:text-lureo-brand-ink"
    >
      <Glyph className="h-3.5 w-3.5" weight={loading ? 'regular' : 'fill'} />
      {label}
    </LureoButton>
  );
}
